import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=4b9f11e8&scoped=true"
import script from "./CommentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CommentDialog.vue?vue&type=style&index=0&id=4b9f11e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f11e8",
  null
  
)

export default component.exports